<template>
    <div class="list-group-item brand-model-box">
        <div class="row d-flex justify-content-between align-items-center mx-0" @click="visible = !visible" role=button>
            <p class="mb-0"><b>{{$t('cat.filter.brands_and_models')}}</b></p>
            <component v-bind:is="getChevronTag" />
        </div>

        <b-collapse :visible="visible">
            <div class="list-group-item border-0 m-0 p-0">
                <div class="row mt-3 mb-3">
                    <div class="col-12 mb-3">
                        <p class="mb-0">{{$t('cat.filter.brands')}}</p>
                        <div class="row mt-3 mb-3">
                            <div class="col-12" v-if="brands.length">
                                <b-form-group v-model="checkedBrands">
                                    <b-form-checkbox-group
                                        v-model="checkedBrands"
                                        stacked
                                    >
                                        <b-form-checkbox
                                            v-for="entry in brands"
                                            :key="entry.id"
                                            :value="entry.value"
                                        >
                                            <span class="break-word">{{ entry.label }}</span>
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-3" v-if="models.length">
                        <p class="mb-0">{{$t('cat.filter.models')}}</p>
                        <div class="row mt-3 mb-3">
                            <div class="col-12">
                                <b-form-group v-model="checkedModels">
                                    <b-form-checkbox-group
                                        v-model="checkedModels"
                                        stacked
                                    >
                                        <b-form-checkbox
                                            v-for="model in models"
                                            :key="model.id"
                                            :value="model.id"
                                        >
                                            <span class="break-word">{{ model.label }}</span>
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { BCollapse, BIconChevronUp, BIconChevronDown, BFormCheckbox, BFormGroup, BFormCheckboxGroup, BFormSelect, BSkeleton } from "bootstrap-vue"
import { EventBus } from "../../event-bus"

export default {
    name: 'FilterBrandModelBoxNew',
    components: {
        BCollapse, BIconChevronUp, BIconChevronDown,
        BFormGroup,
        BFormCheckboxGroup, BFormCheckbox, BFormSelect,
        BSkeleton
    },
    data() {
        return {
            changedByUrl: false,
            brandFilterData: null,
            isLoading: true,
            checkedBrands: [],
            checkedModels: [],
            brands: [],
            models: [],
            visible: false
        }
    },
    methods: {
        initVisibleState() {
            if (this.$route.query.brand) {
                this.visible = true
            }
        },
        getbrandFilterData(data){
            this.brandFilterData = data.find(f => f.name === 'brand')
            this.brands = this.brandFilterData.values

            const oldDefault = this.brands.findIndex(o => o.value === -1);

            if(oldDefault !== -1){
                this.brands.splice(oldDefault, 1)
            }
            if(this.$route.query['brand'] !== undefined && this.$route.query['brand'] !== '' && this.$route.query['brand'].length !== 0){
                this.changedByUrl = true
                const brandIds = this.$route.query['brand'].replace(/[^-0-9\,]/g, '').split(',')

                brandIds.forEach(id => {
                    this.checkedBrands.push(id)
                    let selectedBrand = this.brands.filter(brand => {
                        return brand.id == id
                    })

                    selectedBrand[0].models.forEach(model => {
                        this.models.push(model)
                    })
                })
            }

            if(this.$route.query['model'] !== undefined && this.$route.query['model'] !== '' && this.$route.query['model'].length !== 0){
                const modelIds = this.$route.query['model'].replace(/[^-0-9\,]/g, '').split(',')

                modelIds.forEach(id => {
                    this.checkedModels.push(id)
                })
            }
            this.isLoading = false
        },
        resetFilter(){
            this.changedByUrl = true
            this.checkedBrands = []
            this.checkedModels = []

            EventBus.$emit('update-catalog-filter', {filter: 'model', value: ''})
            EventBus.$emit('update-catalog-filter', {filter: 'brand', value: ''})
        }
    },
    watch: {
        checkedBrands: function (val) {
            // fallback if order is set by url
            if(!this.changedByUrl){
                let string = ''

                if(this.checkedBrands.length !== 0){
                    this.checkedBrands.forEach(function(val, key, array){
                        string = (key === 0) ? val : `${string},${val}`
                    })
                    string = `[${string}]`
                } else {
                    this.models = []
                    EventBus.$emit('update-catalog-filter', {filter: 'brand', value: []})
                    EventBus.$emit('update-catalog-filter', {filter: 'model', value: []})
                }

                EventBus.$emit('update-catalog-filter', {filter: 'brand', value: string})
            } else {
                this.changedByUrl = false
            }
        },
        checkedModels: function (val) {
            // fallback if order is set by url
            if(!this.changedByUrl){
                let string = ''

                if(this.checkedModels.length !== 0){
                    this.checkedModels.forEach(id => {
                        string = string == '' ? id : `${string},${id}`
                    })

                    string = `[${string}]`
                }

                EventBus.$emit('update-catalog-filter', {filter: 'model', value: string})
            } else {
                this.changedByUrl = false
            }
        },
    },
    computed: {
        getChevronTag() {
            return this.visible ? "b-icon-chevron-up" : "b-icon-chevron-down";
        }
    },
    mounted() {
        this.initVisibleState()

        EventBus.$on('catalog-filters-received', this.getbrandFilterData);
        EventBus.$on('catalog-filters-received-modal', this.getbrandFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
